export default [
  {
    key: 'free',
    title: 'свободный'
  }, {
    key: 'authorize',
    title: 'требуется авторизация'
  }
]


// WEBPACK FOOTER //
// ./src/vocabularies/accessModes.js